module.exports = __webpack_public_path__ + "media/bundles/CityInfo/man_icon-0e4ea3d105af4d33c00bcbc27c7eec1e.svg";